import { TLNRChampion, TLNRChampionServer } from '../models'

export const mapFromServer = (payload: TLNRChampionServer): TLNRChampion => ({
  EntryId: payload.EntryId,
  Email: payload.Email || '',
  FirstName: payload.FirstName || '',
  LastName: payload.LastName || '',
  JobTitle: payload.JobTitle || '',
  MobilePhone: payload.MobilePhone || '',
  MobilePhone_Prefix: payload.MobilePhone_Prefix || '',
  RequestId: payload.RequestId,
  WorkPhone: payload.WorkPhone || '',
  WorkPhone_Prefix: payload.WorkPhone_Prefix || '',
})
